import theme from '../../../themes/green';

const styles = {
  wrapper: {
    backgroundColor: theme.pallete.lightBackground,
    height: 2,
    width: '100%',
    margin: '10px 0',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/UIKit/Hr/styles.js